<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
import { Settings, Users } from '@lucide/vue';
import { useAppStore } from '../stores/app';

const store = useAppStore();
</script>

<template>
  <div class="page settings-page">
    <header class="page-header settings-header">
      <div>
        <p class="eyebrow">SETTINGS</p>
        <h1>设置</h1>
        <p>{{ store.canManage ? '配置项目品牌、系统邮箱和成员权限。' : '查看个人账号与知识库权限。' }}</p>
      </div>
    </header>

    <div class="settings-layout">
      <nav class="settings-subnav" aria-label="设置导航">
        <RouterLink :to="{ name: 'settings' }">
          <Settings :size="18" aria-hidden="true" />
          <span>
            <strong>{{ store.canManage ? '系统设置' : '账号设置' }}</strong>
            <small>{{ store.canManage ? '品牌与系统邮箱' : '账号与权限说明' }}</small>
          </span>
        </RouterLink>
        <RouterLink v-if="store.canManage" :to="{ name: 'users' }">
          <Users :size="18" aria-hidden="true" />
          <span><strong>成员管理</strong><small>成员与空间角色</small></span>
        </RouterLink>
      </nav>
      <main class="settings-content">
        <RouterView />
      </main>
    </div>
  </div>
</template>
